module.exports = __webpack_public_path__ + "img/desktop.4e55e6f0.png";